import React, { useState, useEffect } from "react";
import { ArrowDown2, ArrowUp2 } from "iconsax-react";
import Link from "next/link";
import useCategoryMenu from "@/hooks/useCategoryMenu";
import { HeaderMenuType } from "@/types/HeaderType";
import NavbarSkeleton from "@/components/Skeleton/NavbarSkeleton";

interface NavModalType {
  setIsMenuOpen: (value: boolean) => void;
}

function NavCollapse({ setIsMenuOpen }: NavModalType) {
  const [headerMenu, setHeaderMenu] = useState<HeaderMenuType[]>([]);
  const { data, isLoading } = useCategoryMenu();
  const [openCategories, setOpenCategories] = useState<{
    [key: string]: boolean;
  }>({});
  const [openSubCategories, setOpenSubCategories] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    if (data?.isSuccess) {
      setHeaderMenu(data?.data || []);
    }
  }, [data]);

  const toggleCategory = (id: string | number) => {
    setOpenCategories((prev) => ({
      ...prev,
      [String(id)]: !prev[String(id)],
    }));
  };

  const toggleSubCategory = (id: string | number) => {
    setOpenSubCategories((prev) => ({
      ...prev,
      [String(id)]: !prev[String(id)],
    }));
  };
  const generalLinks = `text-sm text-ws-gray-700`;

  if (isLoading) return <NavbarSkeleton />;

  return (
    <>
      <div className="w-full">
        {headerMenu.slice(0, 6).map((category) => (
          <div key={category.id} className="w-full mx-auto">
            <div className="w-full border-b">
              <button
                type="button"
                onClick={() => {
                  toggleCategory(category.id);
                }}
                className="w-full flex items-center justify-between p-4"
              >
                <Link
                  href={`/category/${category?.name}/${category?.id}`}
                  className="text-right"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  {category.name}
                </Link>
                {openCategories[category.id] ? (
                  <ArrowUp2 size={16} color="#000" />
                ) : (
                  <ArrowDown2 size={16} color="#000" />
                )}
              </button>

              {openCategories[category.id] && category.childs && (
                <div className="bg-gray-50">
                  {category.childs.map((subCategory) => (
                    <div key={subCategory.id}>
                      <div
                        onClick={() => {
                          toggleSubCategory(subCategory.id);
                          setIsMenuOpen(false);
                        }}
                        className="px-8 py-2 cursor-pointer hover:bg-gray-100"
                      >
                        <div className="flex items-center justify-between">
                          <Link
                            href={`/category/${subCategory?.name}/${subCategory?.id}`}
                            onClick={() => {
                              setIsMenuOpen(false);
                            }}
                          >
                            <span>{subCategory.name}</span>
                          </Link>
                          {subCategory.childs?.length > 0 &&
                            (openSubCategories[subCategory.id] ? (
                              <ArrowUp2 size={16} color="#000" />
                            ) : (
                              <ArrowDown2 size={16} color="#000" />
                            ))}
                        </div>
                      </div>
                      {openSubCategories[subCategory.id] &&
                        subCategory.childs && (
                          <div className="bg-gray-100">
                            {subCategory.childs.map((finalChild) => (
                              <Link
                                key={finalChild.id}
                                href={`/category/${finalChild.name}/${finalChild.id}`}
                                className="px-12 py-2 block hover:bg-gray-200"
                              >
                                {finalChild.name}
                              </Link>
                            ))}
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col   w-full">
        <Link
          className={`${generalLinks} p-4 cursor-pointer hover:bg-gray-100 w-full border-b border-gray-300`}
          href="/blogList"
          onClick={() => {
            setIsMenuOpen(false);
          }}
        >
          بلاگ
        </Link>
        <Link
          className={`${generalLinks} p-4 cursor-pointer hover:bg-gray-100 w-full border-b border-gray-300`}
          href="/about"
          onClick={() => {
            setIsMenuOpen(false);
          }}
        >
          درباره ما
        </Link>
        <Link
          className={`${generalLinks} p-4 cursor-pointer hover:bg-gray-100 w-full border-b border-gray-300`}
          href="/contact"
          onClick={() => {
            setIsMenuOpen(false);
          }}
        >
          تماس با ما
        </Link>
      </div>
    </>
  );
}

export default NavCollapse;
